
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({})
export default class Row extends Vue {
  @Prop({ required: true })
  title: string
  @Prop({ required: true })
  items: { specie: string, value: number }[];
  @Prop({ default: 0 })
  approximation: number
}